import { enGB, pl } from 'date-fns/locale';

export const getDateFnsLocale = (language: string) => {
  switch (language) {
    case 'pl':
      return pl;
    case 'en':
    default:
      return enGB;
  }
};
